import React from 'react';

import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import { numberFormatter } from '../../../utils/utils';

import { STAR_RATING_THRESHOLD } from '../../constants';
import { RATING_INFO_TEST_ID } from './test-id.constant';

import StarIcon from './StarIcon';

import ratingInfoStyles from './RatingInfo.module.scss';
import styles from './Ratings.module.scss';

import type { IRatingInfoProps } from './RatingInfo.type';

interface IRatingsProps
    extends Pick<IRatingInfoProps, 'starRating' | 'totalRating'> {
    showCircleAfterRating: boolean;
}

export const Ratings: React.FC<IRatingsProps> = ({
    starRating,
    totalRating,
    showCircleAfterRating,
}) => {
    const _showRatings = totalRating > STAR_RATING_THRESHOLD;
    if (!_showRatings) return null;

    return (
        <div
            className={classNames(
                ratingInfoStyles.withTopMargin,
                styles.flexContainer,
            )}
            data-testid={RATING_INFO_TEST_ID.RATINGS_CONTAINER}
        >
            <div
                className={classNames(
                    styles.flexContainer,
                    styles.withCircleAfterContent,
                )}
            >
                <StarIcon />
                <span className={styles.starRatingText}>
                    {starRating.toFixed(1)}
                </span>
            </div>
            <p
                className={classNames(styles.totalRatingText, {
                    [styles.withCircleAfterContent]: showCircleAfterRating,
                })}
            >
                {numberFormatter(totalRating)} {gettext('ratings')}
            </p>
        </div>
    );
};
